import axios from 'axios';
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Header from './components/Header';
import SearchBar from './components/SearchBar';
import ItemsPerPage from './components/ItemsPerPage';
import Sort from './components/Sort';
import FourMinute from './pages/fourMinute';
import OneMinute from './pages/oneMinute';

function App() {
  const [podcastTitle, setPodcastTitle] = useState('');
  const [fourMinEpisodes, setFourMinEpisodes] = useState([]);
  const [query, setQuery] = useState('');
  const [episodesPerPage, setEpisodesPerPage] = useState(10);
  const [sort, setSort] = useState('latest');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const podcastUrl = process.env.REACT_APP_FOUR_MIN_PODCAST_URL;
    const fourMinEpisodesUrl = process.env.REACT_APP_FOUR_MIN_URL;
    const token = process.env.REACT_APP_TOKEN;

    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: {
        Authorization: 'Bearer ' + token
      }
    };

    const fetchPodcast = async () => {
      const res = await axios.get(podcastUrl, requestOptions);
      setPodcastTitle(res.data.title);
    };

    fetchPodcast();

    const fetchEpisodes = async () => {
      setLoading(true);
      const res = await axios.get(
        fourMinEpisodesUrl + `&search=${query}&limit=${episodesPerPage}&sort=${sort}`,
        requestOptions
      );

      setFourMinEpisodes(res.data.collection);
      setLoading(false);
    };

    if (query.length === 0 || query.length > 2) fetchEpisodes();
  }, [query, sort, episodesPerPage]);

  return (
    <Router>
      <div className='App'>
        <Header podcastTitle={podcastTitle} />
        <section className='search-container'>
          <SearchBar query={query} setQuery={setQuery} />
          <Sort sort={sort} setSort={setSort} />
          <ItemsPerPage setEpisodesPerPage={setEpisodesPerPage} />
        </section>
        <Switch>
          <Route exact path='/'>
            <FourMinute
              query={query}
              setQuery={setQuery}
              loading={loading}
              fourMinEpisodes={fourMinEpisodes}
            />
          </Route>
          <Route exact path='/4-minute'>
            <FourMinute />
          </Route>
          <Route exact path='/1-minute'>
            <OneMinute />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
